import { useMemo } from 'react';
import * as React from 'react';

import BicycleNumber from '@/components/elements/Icon/BicycleNumber';
import { Race } from '@/lib/apollo/types/gen/graphql';

import { Column, Title, Wrapper } from './style';

interface LineForecastProps {
  lineForecast: NonNullable<Race['lineForecast']>;
}

const LineForecast: React.FC<LineForecastProps> = ({ lineForecast }) => {
  const displayForecast = useMemo(() => {
    return [...Array(17)].map((_, columnIndex) =>
      lineForecast.map(lineIndex => lineIndex[columnIndex] || null).reverse(),
    );
  }, [lineForecast]);

  return (
    <>
      <Title>並び予想</Title>
      <Wrapper>
        {displayForecast.map((column, i) => (
          <Column key={`column-${i}`}>
            {column.map((num, j) => (
              <React.Fragment key={`bicyclenum-${num}-${j}`}>
                <div>
                  {num && <BicycleNumber bicycleNum={num}>{num}</BicycleNumber>}
                </div>
              </React.Fragment>
            ))}
          </Column>
        ))}
      </Wrapper>
    </>
  );
};

export default LineForecast;
